import { Pipe, PipeTransform } from '@angular/core';
import { InvoicePaymentMethod } from '~core/models/invoice.models';
import { PaymentMethod } from '~core/models/payment.models';
import { ReceiptPaymentMethod } from '~core/models/receipt.models';

@Pipe({
  name: 'paymentMethod',
  pure: true,
  standalone: true
})
export class PaymentMethodPipe implements PipeTransform {
  private readonly _methodMap: Record<
    PaymentMethod | ReceiptPaymentMethod | InvoicePaymentMethod,
    string
  > = {
    [PaymentMethod.ORANGE_MONEY]: 'Orange Money',
    [PaymentMethod.MOOV_MONEY]: 'Moov Money',
    [PaymentMethod.MTN_MONEY]: 'MTN Money',
    [PaymentMethod.MOBILE_MONEY]: 'Mobile Money',
    [PaymentMethod.CREDIT_CARD]: 'Carte bancaire',
    [PaymentMethod.WAVE_MONEY]: 'Wave Money',
    [PaymentMethod.TPE]: 'TPE',
    [PaymentMethod.VISA]: 'Visa',
    [PaymentMethod.MASTERCARD]: 'Mastercard',
    [ReceiptPaymentMethod.CASH]: 'Espèces',
    [ReceiptPaymentMethod.CARD]: 'Carte bancaire',
    [ReceiptPaymentMethod.DEFERRED]: 'Paiement à terme',
    [InvoicePaymentMethod.check]: 'Chèque',
    [InvoicePaymentMethod.bankCard]: 'Carte bancaire',
    [InvoicePaymentMethod.eventually]: 'Paiement à terme',
    [InvoicePaymentMethod.transfer]: 'Virement'
  };

  transform(
    method:
      | PaymentMethod
      | ReceiptPaymentMethod
      | InvoicePaymentMethod
      | undefined
  ): string {
    if (!method) {
      return 'Inconnue';
    }

    return this._methodMap[method] || method;
  }
}
